import useAuth from '../../app/src/features/authentication/hooks/useAuth';
import { NewCreateFlowPayload } from '../../flows/src/types/ApiTypes';
import store from '../store/redux/store';

interface CompanyScanFlowQueryParams {
  getFlowPayload: (partyId?: string) => NewCreateFlowPayload;
}

const useCompanyScanPayload = (): CompanyScanFlowQueryParams => {
  const { campaign } = useAuth();

  const getFlowPayload = (partyId?: string) => {
    const { expectanceAsBroker, hearAboutUs } =
      store.getState().companyScan.welcomeData || {};

    return {
      ...(partyId && { party_id: partyId }),
      ...(expectanceAsBroker && { broker_expectations: expectanceAsBroker }),
      ...(hearAboutUs && { how_found_broker: hearAboutUs }),
      ...(campaign?.short_id && { campaign_id: campaign?.short_id }),
    };
  };

  return { getFlowPayload };
};

export default useCompanyScanPayload;
